module.exports = __webpack_public_path__ + "static/media/cx.f2fe7dd4.svg";